import {CommonUtil} from './CommonUtil.js';

var replaceUtil = {
  replace: function (replace, value) {
    return replaceValue(replace, value);
  }
}

function replaceValue(replace, value) {
  switch(replace){
    case 'number':
      return replaceNumber(value);
    case 'minNumber':
      return replaceMinNumber(value);
    case 'letter':
      return replaceLetter(value);
    case 'numberOrLetter':
      return replaceNumberOrLetter(value);
    case 'upperCase':
      return replaceUpperCase(value);
    case 'numberOrUpperCase':
      return replaceNumberOrUpperCase(value);
    case 'money':
      return replaceMoney(value);
    case 'maxMoney':
      return replaceMaxMoney(value);
    case 'year':
      return replaceYear(value);
    case 'idCard':
      return replaceIdCard(value);
    case 'catalogueCode':
      return replaceCatalogueCode(value);
    case 'frameCode':
      return replaceFrameCode(value);
    case 'classificationNumber':
      return replaceClassificationNumber(value);
    case 'date':
      return replaceDate(value);
    case 'warehouseFrameCode':
      return replaceWarehouseFrameCode(value);
    case 'hallCodeAndBarNumber':
      return replaceHallCodeAndBarNumber(value);
    case 'hallCodeBarNumber':
      return replaceHallCodeBarNumber(value);
    case 'circulateCode':
      return replaceCirculateCode(value);
    case 'borrowCode':
      return replaceBorrowCode(value);
    case 'returnCode':
      return replaceReturnCode(value);
    case 'circulateCodeOrBorrowCode':
      return replaceCirculateCodeOrBorrowCode(value);
    case 'circulateCodeOrReturnCode':
      return replaceCirculateCodeOrReturnCode(value);
    case 'PDCode':
      return replacePDCode(value);//盘亏
    case 'TJCode':
      return replaceTJCode(value);//剔旧
    case 'depositCode':
      return replaceDepositCode(value);//用于收款统计 单号
    case 'isbn':
      return replaceIsbn(value);
    case 'chineseClassificationNumber':
      return replaceChineseClassificationNumber(value);
    case 'JSCodeOrHSCode':
      return replaceJSCodeOrHSCode(value);
    default:
      return '';
  }
}

/**
 * 替换文本里面的非数字部分
 * @param text
 */
function replaceNumber(text) {
  return text.replace(/[^0-9]/g,"");
}

/**
 * 替换为纯数字,且最小值为1
 * @param text
 * @returns {*}
 */
function replaceMinNumber(text) {
  text=replaceNumber(text);
  if(text!=null && text!='' && parseInt(text)<1){
    text='';
  }
  return text;
}

/**
 * 替换字母
 * @param text
 */
function replaceLetter(text) {
  return text.replace(/[^a-zA-Z]/g,"");
}

/**
 * 替换大写字母
 * @param text
 * @returns {string}
 */
function replaceUpperCase(text){
  return replaceLetter(text).toUpperCase();
}

/**
 * 替换文本里面的非数字和字母部分
 * @param text
 */
function replaceNumberOrLetter(text) {
  return text.replace(/[^0-9a-zA-Z]/g,"");
}

function replaceNumberOrUpperCase(text) {
  text=replaceNumberOrLetter(text);
  return text.toUpperCase();
}

/**
 * 替换金额
 * @param text
 * @returns {string}
 */
function replaceMoney(text){
  var newPrice="";
  var temp=text.indexOf(".",0);
  if (temp>0) {
    var p1=text.substring(0,temp);
    var p2=text.substring(temp+1);
    p1=p1.replace(/[^0-9]/g,"");
    p2=p2.replace(/[^0-9]/g,"");
    if (p2.length>2) {
      p2=p2.substring(0,2);
    }
    newPrice=p1+"."+p2;
  }else{
    newPrice=text.replace(/[^0-9]/g,"");
  }
  return newPrice;
}

function replaceMaxMoney(text) {
  text=replaceMoney(text);
  if(text!=''){
    var num='';
    if(text.indexOf(".",0)>0){
      num=text.substring(0,text.indexOf(".",0));
    }else{
      num=text;
    }
    if(num.length>6){
      text=num.substring(0,6);
    }
  }
  return text;
}

/**
 * 替换年份(只能4位数字,首位不能为0)
 * @param text
 */
function replaceYear(text){
  var newYear=text.replace(/[^0-9]*$/g,"");
  if (newYear.length>=1 && newYear.substring(0,1)=="0") {
    newYear=newYear.substring(1);
  }
  if (newYear.length>4) {
    newYear=newYear.substring(0,4);
  }
  return newYear;
}

/**
 * 替换日期
 * @param text
 */
function replaceDate(text) {
  return text.replace(/[^0-9年月日.-/-]/g,"");
}

/**
 * 替换身份证(只能为数字,如果为18位则最后一位可以为字母X)
 * @param text
 * @returns {string|*}
 */
function replaceIdCard(text) {
  text=replaceNumberOrLetter(text).toUpperCase();
  if(text.length<18){
    text=replaceNumber(text);
  }else if(text.length==18){
    if(text.substring(text.length-1)=='X'){
      var num=replaceNumber(text.substring(0,17));
      if(num.length!=17){
        text=replaceNumber(text);
      }
    }else{
      text=replaceNumber(text);
    }
  }else{
    text=replaceNumber(text);
    if(text.length>18){
      text=text.substring(0,18);
    }
  }
  return text;
}

/**
 * 替换不符合规则的编目号
 * 第一个字符只能为B或数字,第二个字符只能为M或数字,后面字符只能为数字
 * (如果第一个字符为B,则第二个字符只能为M,后面字符只能为8位以内数字.如果第一个字符为数字,则所有字符都只能为8位以内数字)
 */
function replaceCatalogueCode(text){
  return replaceLetterAndCode(text,'BM',8);
}

/**
 * 替换排架号(只能为数字,字母,汉字,-)
 * @param text
 */
function replaceFrameCode(text){
  text=text.replace(/[^0-9a-zA-Z\u4e00-\u9fa5-]*$/g,"");
  var newText='';
  if(text!='' && text.indexOf('-')!=-1){
    if(text.charAt(0)=='-'){
      return '';
    }else{
      newText=text.substring(0,text.indexOf('-')+1);
      newText+=text.substring(text.indexOf('-')+1).replace('-','');
    }
  }else{
    newText=text;
  }
  return CommonUtil.substringByByteLength(newText,9);
}

/**
 * 替换分类号
 * @param text
 */
function replaceClassificationNumber(text){
  return text.replace(/[^0-9a-zA-Z.\\/-]*$/g,"").toUpperCase();
}

/**
 * 替换isbn
 * @param text
 * @returns {*}
 */
function replaceIsbn(text) {
  text=replaceNumberOrUpperCase(text);
  if(text.length==10){
    //如果为10位的isbn,则前9位为数字.最后一位为数字或X
    var num=text.substring(0,9);
    num=replaceNumber(num);
    if(num.length<9){
      text='';
    }else{
      var last=text.substring(9);
      if(last=='X'){
        text=num+last;
      }else{
        text=num+replaceNumber(last);
      }
    }
  }else if(text.length<10){
    text=replaceNumber(text);
  }else{
    if(text.charAt(9)=='X'){
      var newText=replaceIsbn(text.substring(0,10));
      if(newText.length==10){
        text=newText;
      }else{
        text=replaceNumber(text);
      }
    }else{
      text=replaceNumber(text);
    }
  }
  return text;
}

function replaceChineseClassificationNumber(text) {
  text=replaceNumberOrUpperCase(text);
  if(text.length>0){
    if(/^[A-Z]*$/.test(text.charAt(0))){
      var letter=text.charAt(0);
      var number='';
      if(text.length>1){
        number=text.substring(1);
        number=replaceNumber(number);
        if(number.length>3){
          number=number.substring(0,3);
        }
      }
      text=letter+number;
    }else{
      text='';
    }
  }
  return text;
}

/**
 * 替换排架实体的排架号(不能包含-,避免编目时和溢架号混淆,只能为数字,大写字母和汉字,最大字节长度为6)
 * @param text
 */
function replaceWarehouseFrameCode(text) {
  text=text.replace(/[^0-9a-zA-Z\u4e00-\u9fa5]*$/g,"");
  return CommonUtil.substringByByteLength(text,6);
}

//只能为字母数字，数字只能包含8位  用于收款统计
function replaceDepositCode(text) {
  text=text.replace( /[^0-9a-zA-Z]/g,"");
  var chineseNum=0,returnTest='';
  for (var i=0; i<text.length; i++){
    if(/[^a-zA-Z]/g.test(text.charAt(i))){
      if(chineseNum<8){
        returnTest+=text.charAt(i);
        chineseNum++;
      }
    }else{
      returnTest+=text.charAt(i);
    }
  }
  return returnTest;
}


function replaceHallCodeAndBarNumber(text) {
  text=replaceNumberOrLetter(text);
  if(text=='' || text.length==0){
    return text;
  }else{
    if(/[0-9]$/.test(text.charAt(0))){
      //如果首位为数字,则由条码号组成
      text=replaceNumber(text);
      if(text.length>7){
        text=text.substring(0,7);
      }
      return text;
    }else{
      //如果首位为字母,则由馆号+条码号组成,前四位或五位只能为字母,后面只能为不超过7位的数字
      text=text.toUpperCase();
      if(text.length<=4){
        text=replaceLetter(text);
        return text;
      }
      var hallCode=text.substring(0,4);
      var barNumber=text.substring(4);
      if(/[A-Z]$/.test(text.charAt(4))){//如果第五位为字母,则为五位馆号+条码号
        hallCode=text.substring(0,5);
        barNumber=text.substring(5);
      }
      hallCode=replaceLetter(hallCode);
      if(hallCode.length<4){
        return hallCode;
      }else{
        barNumber=replaceNumber(barNumber);
        if(barNumber.length>7){
          barNumber=barNumber.substring(0,7);
        }
        return hallCode+barNumber;
      }
    }
  }
}

/**
 * 只能由馆号加条码号组成,不能只输入条码号
 * @param text
 * @returns {*}
 */
function replaceHallCodeBarNumber(text) {
  text=replaceNumberOrUpperCase(text);
  if(text.length>0){
    if(/[0-9]$/.test(text.charAt(0))){
      text='';
    }else{
      text=replaceHallCodeAndBarNumber(text);
    }
  }
  return text;
}

/**
 * 字母和数字组成的单号替换
 * @param text 需要替换的值
 * @param letter 单号前面的字母(大写)
 * @param len 单号后面的数字部分长度
 * @returns {*替换后的值}
 */
function replaceLetterAndCode(text,letter,len) {
  text=replaceNumberOrUpperCase(text);
  if(text=='' || text.length==0){
    return text;
  }else{
    if(/[0-9]$/.test(text.charAt(0))){
      //如果首位为数字,则为纯数字
      text=replaceNumber(text);
      if(text.length>len){
        text=text.substring(0,len);
      }
      return text;
    }else{
      //如果首位为字母,则由指定字母+数字组成,前面部分只能为指定,后面只能为不超过指定长度的数字
      text=text.toUpperCase();
      if(text.length<=letter.length){
        return replaceText(letter,text);
      }else if(text.length>letter.length){
        var newLetter=text.substring(0,letter.length);
        var number=text.substring(letter.length);
        if(newLetter!=letter){
          newLetter='';
        }
        number=replaceNumber(number);
        if(number.length>len){
          number=number.substring(0,len);
        }
        return newLetter+number;
      }
    }
  }
}

function replaceCirculateCode(text) {
  return replaceLetterAndCode(text,'LT',8);
}

function replaceBorrowCode(text) {
  return replaceLetterAndCode(text,'JS',8);
}

function replaceReturnCode(text) {
  return replaceLetterAndCode(text,'HS',8);
}

//盘亏
function replacePDCode(text) {
  return replaceLetterAndCode(text,'PD',8);
}

//剔旧
function replaceTJCode(text) {
  return replaceLetterAndCode(text,'TJ',8);
}

/**
 * 多种字母和数字组成的单号替换
 * @param text
 * @param letterArr 字母数组(内部每种字母规则长度需一致为下面参数letterLen,且为大写)
 * @param len 后面数字部分长度
 * @param letterLen 前面字母部分长度
 * @returns {*}
 */
function replaceLettersAndCode(text,letterArr,len,letterLen) {
  text=replaceNumberOrLetter(text);
  if(text=='' || text.length==0){
    return text;
  }else{
    if(/[0-9]$/.test(text.charAt(0))){
      //如果首位为数字,则为纯数字
      text=replaceNumber(text);
      if(text.length>len){
        text=text.substring(0,len);
      }
      return text;
    }else{
      //如果首位为字母,则由指定字母+数字组成,前面部分只能为指定,后面只能为不超过指定长度的数字
      text=text.toUpperCase();
      if(text.length<=letterLen){
        var newText='';
        for(var i=0;i<letterArr.length;i++){
          newText=replaceText(letterArr[i],text);
          if(newText!=''){
            break;
          }
        }
        return newText;
      }else if(text.length>letterLen){
        var letter=text.substring(0,letterLen);
        var number=text.substring(letterLen);
        var isTrue=false;
        for(var i=0;i<letterArr.length;i++){
          if(letter==letterArr[i]){
            isTrue=true;
            break;
          }
        }
        if(!isTrue){
          letter='';
        }
        number=replaceNumber(number);
        if(number.length>len){
          number=number.substring(0,len);
        }
        return letter+number;
      }
    }
  }
}

function replaceCirculateCodeOrBorrowCode(text) {
  if (text.length>0 && /[0-9]$/.test(text.charAt(0))){
    return "";
  }
  return replaceLettersAndCode(text,['LT','JS'],8,2);
}

function replaceCirculateCodeOrReturnCode(text) {
  if (text.length>0 && /[0-9]$/.test(text.charAt(0))){
    return "";
  }
  return replaceLettersAndCode(text,['LT','HS'],8,2);
}

//收款统计
function replaceJSCodeOrHSCode(text) {
  if (text.length>0 && /[0-9]$/.test(text.charAt(0))){
     return "";
  }
  return replaceLettersAndCode(text,['JS','HS'],8,2);
}

function replaceText(regexStr,text) {
  var newText='';
  for(var i=0;i<regexStr.length;i++){
    if(text.length>=i && regexStr.charAt(i)==text.charAt(i)){
      newText+=regexStr.charAt(i);
    }else{
      break;
    }
  }
  return newText;
}

export {replaceUtil};
